import { InjectionToken, FactoryProvider } from '@angular/core';

export const WindowProvider = new InjectionToken<Window>('window');

const windowProvider: FactoryProvider = {
    provide: WindowProvider,
    useFactory: () => window
};

export const WINDOW_PROVIDERS = [
    windowProvider
];
